<template>
  <div class="header_wrapper">
    <header class="header"
            style="translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0%);">
      <div class="header-mobile-block" bis_skin_checked="1">
        <a href="/" aria-current="page" class="header__logo w-inline-block w--current">
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 748 101" fill="none">
            <path
                d="M195.15 19.715H219.175C226.8 19.715 232.52 21.7343 236.332 25.7682C240.209 29.7538 242.14 34.6729 242.14 40.5233C242.14 46.3737 240.144 51.2144 236.161 55.1999C232.17 59.0679 226.184 60.995 218.205 60.995H208.171V82.7484H195.152V19.715H195.15ZM208.169 49.5732H218.647C221.87 49.5732 224.379 48.7041 226.17 46.9684C227.956 45.2372 228.85 43.0335 228.85 40.3596C228.85 37.6857 227.987 35.6664 226.258 33.9606C224.524 32.2548 222.222 31.4042 219.344 31.4042H208.166V49.5732H208.169Z"
                fill="#282828"></path>
            <path d="M251.384 82.7484V19.715H264.493V82.7484H251.384Z" fill="#282828"></path>
            <path
                d="M274.22 19.715H298.246C305.87 19.715 311.59 21.7343 315.402 25.7682C319.279 29.7538 321.21 34.6729 321.21 40.5233C321.21 46.3737 319.215 51.2144 315.231 55.1999C311.24 59.0679 305.254 60.995 297.275 60.995H287.241V82.7484H274.223V19.715H274.22ZM287.239 49.5732H297.718C300.94 49.5732 303.449 48.7041 305.24 46.9684C307.026 45.2372 307.92 43.0335 307.92 40.3596C307.92 37.6857 307.057 35.6664 305.328 33.9606C303.594 32.2548 301.292 31.4042 298.414 31.4042H287.236V49.5732H287.239Z"
                fill="#282828"></path>
            <path
                d="M374.258 82.7484H330.172V19.715H374.258V31.4849H343.281V45.0459H371.97V56.8204H343.281V70.9785H374.258V82.7484Z"
                fill="#282828"></path>
            <path d="M383.275 82.7853V21.1857H389.587V77.3199H425.972V82.7853H383.275Z" fill="#282828"></path>
            <path
                d="M462.435 83.9125C452.796 83.9125 445.048 80.9389 438.738 74.8211C432.35 68.6365 429.253 61.2417 429.253 52.2195C429.253 43.1972 432.386 35.6388 438.835 29.3181C445.335 23.0252 453.091 19.9617 462.533 19.9617C471.974 19.9617 479.687 23.0229 486.132 29.3251C492.653 35.6457 495.814 43.0682 495.814 52.0281C495.814 60.9881 492.656 68.3783 486.154 74.6229C479.701 80.8767 471.948 83.9102 462.435 83.9102V83.9125ZM462.533 25.8005C455.241 25.8005 448.915 28.3477 443.744 33.3498C438.645 38.2989 436.053 44.5872 436.053 52.0281C436.053 59.4691 438.602 65.6537 443.632 70.5913C448.753 75.5611 455.108 78.0737 462.533 78.0737C469.958 78.0737 476.319 75.5611 481.418 70.612C486.532 65.6629 489.088 59.3953 489.012 51.989C489.012 44.5895 486.427 38.3081 481.328 33.359C476.158 28.3477 469.834 25.8028 462.533 25.8028V25.8005Z"
                fill="#282828"></path>
            <path
                d="M536.337 83.818C526.536 83.818 518.678 80.8974 512.302 74.8765C506.088 68.8532 503.055 61.3731 503.055 52.0305C503.055 42.6878 506.199 35.0625 512.673 29.0139C519.187 22.9238 527.123 19.964 536.917 19.964C542.052 19.964 547.003 20.8883 551.627 22.7209C554.871 24.0049 557.715 25.6138 560.117 27.5132L556.11 31.757C550.611 27.6216 544.173 25.5239 536.917 25.5239C529.176 25.5239 522.626 28.0642 517.458 33.0663C512.288 38.0776 509.662 44.4328 509.662 51.9406C509.662 59.4483 512.197 65.58 517.192 70.6466C522.41 75.7801 528.966 78.3595 536.722 78.3595C540.863 78.3595 544.939 77.5781 548.835 76.0452C552.749 74.4961 556.105 72.3916 558.809 69.7776C559.572 69.0376 560.008 68.0326 560.008 66.9861V57.4867C560.008 55.3083 558.186 53.5426 555.938 53.5426H540.213V49.2989H564.962V72.3224C556.835 80.0561 547.455 83.818 536.339 83.818H536.337Z"
                fill="#282828"></path>
            <path d="M582.476 21.1857H576.165V82.7876H582.476V21.1857Z" fill="#282828"></path>
            <path
                d="M624.444 83.818C614.967 83.818 607.29 80.9528 600.978 75.0517C594.702 69.1436 591.648 61.6705 591.648 52.2195C591.648 42.7685 594.766 35.1432 601.182 29.0945C607.697 22.9491 615.366 19.9617 624.642 19.9617C630.385 19.9617 635.786 21.1373 640.705 23.4655C644.403 25.2104 647.521 27.4303 650.02 30.0788L646.049 33.8546C640.208 28.32 633.284 25.5239 625.412 25.5239C617.54 25.5239 611.38 28.1033 606.22 33.1884C601.078 38.1721 598.452 44.5872 598.452 52.2195C598.452 59.8517 601.044 65.9557 606.144 70.8978C611.25 75.8469 617.702 78.3595 625.317 78.3595C633.52 78.3595 640.617 75.5012 646.472 69.8513L650.472 73.3828C647.839 76.0844 644.61 78.3733 640.826 80.1921C635.832 82.6032 630.319 83.818 624.449 83.818H624.444Z"
                fill="#282828"></path>
            <path
                d="M717.953 82.7484H704.221L699.379 69.0998H676.676L671.662 82.7484H658.021L682.84 19.715H693.483L717.953 82.7484ZM695.688 57.8416L688.12 36.8581L680.374 57.8416H695.688Z"
                fill="#0029B2"></path>
            <path d="M725.872 82.7484V19.715H738.981V82.7484H725.872Z" fill="#0029B2"></path>
            <path
                d="M126.117 51.2468C126.117 41.4316 134.329 33.479 144.441 33.479C154.554 33.479 162.778 41.4293 162.778 51.2468C162.778 61.0643 154.575 69.0147 144.441 69.0147C134.307 69.0147 126.117 61.062 126.117 51.2468Z"
                fill="#0029B2"></path>
            <path
                d="M35.5507 63.4522C35.9194 63.0833 36.2119 62.6684 36.5591 62.2789C36.8326 61.9469 37.1323 61.6426 37.3772 61.2969C45.5799 52.8717 60.1373 52.9085 68.3019 61.3914C68.4375 61.5896 68.6159 61.7487 68.7586 61.9331C69.1676 62.4402 69.5553 62.9496 70.0119 63.4107L70.3353 63.6827C71.1321 64.4848 71.9787 65.2363 72.9277 65.8656L72.9467 65.8794C73.1845 66.0454 73.4461 66.1699 73.703 66.3082C74.3499 66.7047 75.0301 67.0689 75.7459 67.3847C76.0931 67.5437 76.4689 67.6728 76.8423 67.8134C77.5249 68.0578 78.2264 68.2698 78.9494 68.4473C79.2895 68.5326 79.6296 68.6133 79.984 68.6778C81.0661 68.8761 82.172 69.0075 83.3088 69.0075C93.4284 69.0075 101.648 61.0548 101.648 51.2396C101.648 46.3851 99.6261 41.9938 96.3679 38.7874L96.3869 38.8035C96.356 38.7713 96.3299 38.7367 96.2989 38.7044C96.2871 38.6929 96.2799 38.6814 96.268 38.6698C95.5046 37.9161 94.6912 37.213 93.7922 36.616L95.545 38.0913C92.2939 35.2491 88.0297 33.4718 83.3112 33.4718C82.1744 33.4718 81.0709 33.6032 79.9864 33.8014C79.632 33.8614 79.2919 33.9467 78.9518 34.025C78.2288 34.2117 77.5272 34.4169 76.8447 34.6589C76.4713 34.7972 76.0955 34.9379 75.7483 35.0969C75.0324 35.4058 74.3499 35.77 73.7054 36.1665C73.4461 36.3117 73.1869 36.4316 72.9491 36.5952L72.93 36.616L70.0547 39.0202L70.0404 39.034C69.6861 39.4029 69.3721 39.8132 69.0392 40.2074C68.7657 40.5393 68.4589 40.8343 68.2139 41.1847C60.016 49.6076 45.461 49.5731 37.2964 41.0879C37.1608 40.8943 36.9824 40.7375 36.8398 40.5531C36.4331 40.0391 36.0311 39.5366 35.5721 39.0686L35.2796 38.822C34.4781 38.0129 33.6267 37.2545 32.6706 36.6183L32.6445 36.5975C32.4067 36.4339 32.1379 36.314 31.9025 36.1688C31.2413 35.7723 30.5611 35.4081 29.85 35.0992C29.4885 34.9402 29.127 34.8019 28.7536 34.6612C28.0711 34.4192 27.3623 34.2118 26.6536 34.0273C26.2992 33.949 25.9592 33.8637 25.6119 33.8037C24.5274 33.6078 23.4311 33.4741 22.2871 33.4741C12.1604 33.4741 3.94824 41.4245 3.94824 51.242C3.94824 61.0594 12.1604 69.0098 22.2871 69.0098C23.4334 69.0098 24.5298 68.8784 25.6119 68.6802C25.9592 68.6133 26.3016 68.5349 26.6536 68.4496C27.3623 68.2698 28.0711 68.0601 28.7536 67.8157C29.127 67.6774 29.4885 67.546 29.85 67.387C30.5587 67.0712 31.2389 66.707 31.9025 66.3105C32.1403 66.1722 32.4067 66.0454 32.6445 65.8818L32.6706 65.8679L35.5531 63.4568V63.4498L35.5507 63.4522Z"
                fill="#0029B2"></path>
            <path
                d="M96.7046 39.0733L96.3931 38.8105C96.9472 39.3684 97.4871 39.9377 97.9722 40.5601C97.5632 40.0461 97.1612 39.5436 96.7046 39.0756V39.0733Z"
                fill="#0029B2"></path>
            <path
                d="M129.353 41.187C129.598 40.8389 129.897 40.5485 130.168 40.2166C129.897 40.5485 129.59 40.8435 129.338 41.1939C129.338 41.1939 129.353 41.1939 129.353 41.187Z"
                fill="#0029B2"></path>
            <path
                d="M131.473 63.6874C130.919 63.1296 130.376 62.5579 129.894 61.9332C130.293 62.4404 130.697 62.9498 131.147 63.4108L131.473 63.6851V63.6874Z"
                fill="#0029B2"></path>
            <path
                d="M114.688 63.2956C113.549 63.2956 112.46 63.427 111.368 63.6252C111.007 63.6852 110.674 63.7705 110.327 63.8488C109.611 64.0356 108.912 64.2384 108.229 64.4827C107.846 64.6211 107.48 64.7524 107.126 64.9184C106.417 65.2273 105.741 65.5915 105.083 65.9857C104.838 66.1309 104.571 66.2508 104.333 66.4098H104.326L104.307 66.4352L101.43 68.8394V68.8532C101.068 69.2244 100.757 69.6324 100.428 70.0265C100.148 70.3562 99.8433 70.6489 99.5983 70.997V71.0039C91.3933 79.4268 76.8359 79.3945 68.6879 70.9071C68.5452 70.7135 68.3669 70.5544 68.217 70.37C67.8151 69.8629 67.4203 69.3535 66.9637 68.8855L66.6236 68.5997C65.8316 67.8044 64.9897 67.0599 64.0408 66.4329L64.0336 66.4075H64.0194C63.7887 66.2485 63.5223 66.1286 63.2702 65.9834C62.6233 65.5892 61.9408 65.225 61.2392 64.9161C60.8777 64.7501 60.5114 64.6187 60.1356 64.4804C59.4483 64.2338 58.7515 64.0309 58.0309 63.8465C57.6837 63.7659 57.334 63.6829 56.9892 63.6229C55.9047 63.427 54.8155 63.2933 53.6572 63.2933C43.5448 63.2933 35.3374 71.2436 35.3374 81.0611C35.3374 90.8786 43.5424 98.829 53.6572 98.829C54.8155 98.829 55.9047 98.6976 56.9892 98.4993C57.3364 98.4325 57.6837 98.3541 58.0309 98.2734C58.7515 98.089 59.4483 97.877 60.1356 97.6395C60.5114 97.4943 60.8777 97.3606 61.2392 97.2062C61.9408 96.8904 62.6233 96.5239 63.2702 96.1274C63.5223 95.9914 63.7863 95.8669 64.0194 95.6986H64.0336L64.0408 95.6848L66.9304 93.2737V93.2667C67.299 92.8979 67.6034 92.4807 67.9388 92.0934C68.2123 91.7592 68.5167 91.4572 68.764 91.1115C76.9691 82.6863 91.5193 82.7162 99.6744 91.206C99.8171 91.4042 99.9955 91.5633 100.145 91.7477C100.547 92.2548 100.949 92.7642 101.399 93.2252L101.727 93.5019C102.521 94.3017 103.366 95.0509 104.31 95.6802L104.329 95.694H104.336C104.574 95.86 104.84 95.9868 105.085 96.1228C105.746 96.5193 106.422 96.8858 107.128 97.2016C107.482 97.3583 107.849 97.4897 108.231 97.6349C108.914 97.8724 109.613 98.0844 110.329 98.2688C110.676 98.3495 111.012 98.4279 111.371 98.4947C112.462 98.693 113.552 98.8244 114.691 98.8244C124.818 98.8244 133.027 90.8717 133.027 81.0565C133.027 71.2413 124.815 63.2887 114.691 63.2887L114.688 63.2956Z"
                fill="#0029B2"></path>
            <path
                d="M53.6509 39.2001C54.8092 39.2001 55.8984 39.0687 56.9829 38.8705C57.3301 38.8036 57.6774 38.7253 58.0246 38.64C58.7452 38.4602 59.442 38.2504 60.1294 38.0061C60.5051 37.8677 60.8714 37.7341 61.2329 37.5773C61.9345 37.2592 62.617 36.8973 63.2639 36.5008C63.516 36.3625 63.78 36.2357 64.0131 36.0721H64.0274L64.0345 36.0582L66.9241 33.6471V33.6425C67.2927 33.2713 67.5971 32.8564 67.9325 32.4599C68.206 32.1372 68.5104 31.833 68.7577 31.4895C76.9628 23.062 91.513 23.0989 99.6681 31.5817C99.8108 31.7799 99.9892 31.939 100.139 32.1257C100.541 32.6259 100.943 33.1423 101.392 33.6033L101.721 33.8799C102.515 34.6798 103.359 35.4289 104.303 36.0582L104.322 36.0721H104.33C104.567 36.238 104.834 36.3625 105.079 36.5008C105.74 36.8973 106.415 37.2592 107.122 37.5773C107.476 37.7364 107.842 37.8677 108.225 38.0061C108.908 38.2504 109.607 38.4602 110.323 38.64C110.67 38.7253 111.005 38.8059 111.364 38.8705C112.442 39.0687 113.545 39.2001 114.685 39.2001C124.811 39.2001 133.021 31.2475 133.021 21.4323C133.021 11.6171 124.809 3.66443 114.685 3.66443C113.545 3.66443 112.442 3.79582 111.364 3.99406C111.003 4.05399 110.67 4.13929 110.323 4.21997C109.607 4.39746 108.908 4.60953 108.225 4.85388C107.842 4.99218 107.476 5.13279 107.122 5.28953C106.413 5.60072 105.737 5.96494 105.079 6.35911C104.834 6.50433 104.567 6.6242 104.33 6.78786H104.322L104.303 6.80861L101.426 9.21285V9.22668C101.064 9.5955 100.753 10.0058 100.424 10.4C100.139 10.7319 99.8394 11.0224 99.5944 11.3727V11.3797C91.3894 19.8003 76.832 19.768 68.684 11.2875C68.5413 11.0823 68.3629 10.9302 68.2131 10.7458C67.8112 10.2317 67.4164 9.7292 66.9598 9.26126L66.6125 8.97081C65.8229 8.17785 64.9787 7.43561 64.0369 6.81092L64.0297 6.79017H64.0155C63.7848 6.6242 63.5184 6.50664 63.2663 6.36142C62.6194 5.96724 61.9369 5.60303 61.2353 5.29184C60.8738 5.13509 60.5075 4.99678 60.1317 4.85617C59.4444 4.61183 58.7476 4.39976 58.027 4.22226C57.6797 4.14158 57.3301 4.0563 56.9853 3.99637C55.9008 3.80043 54.8115 3.66674 53.6533 3.66674C43.5409 3.66674 35.3335 11.6171 35.3335 21.4346C35.3335 31.2521 43.5385 39.2024 53.6533 39.2024L53.6509 39.2001Z"
                fill="#0029B2"></path>
          </svg>
        </a>
        <div data-burger="" data-w-id="149e6911-2172-61b2-4bbe-16f03b2c8a9c" class="burger" bis_skin_checked="1">
          <div data-is-ix2-target="1" class="lottie" data-w-id="149e6911-2172-61b2-4bbe-16f03b2c8a9d"
               data-animation-type="lottie"
               data-src="https://cdn.prod.website-files.com/6883e59d1edb3d9f8946629d/688a065365ccfa3168889e56_Flow%201.lottie"
               data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-default-duration="0"
               data-duration="0.016666666666666666" bis_skin_checked="1">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32"
                 width="32" height="32" preserveAspectRatio="xMidYMid meet"
                 style="width: 100%; height: 100%; transform: translate3d(0px, 0px, 0px); content-visibility: visible;">
              <defs>
                <clipPath id="__lottie_element_2">
                  <rect width="32" height="32" x="0" y="0"></rect>
                </clipPath>
                <clipPath id="__lottie_element_4">
                  <path d="M0,0 L32,0 L32,32 L0,32z"></path>
                </clipPath>
                <clipPath id="__lottie_element_11">
                  <path d="M0,0 L32,0 L32,32 L0,32z"></path>
                </clipPath>
              </defs>
              <g clip-path="url(#__lottie_element_2)">
                <g clip-path="url(#__lottie_element_4)" transform="matrix(1,0,0,1,0,0)" opacity="1"
                   style="display: block;">
                  <g transform="matrix(1,0,0,1,0,0)" opacity="1" style="display: block;"></g>
                  <g clip-path="url(#__lottie_element_11)" transform="matrix(1,0,0,1,0,0)" opacity="1"
                     style="display: block;">
                    <g transform="matrix(1,0,0,1,0,0)" opacity="1" style="display: block;"></g>
                    <g transform="matrix(1,0,0,1,0,7)" opacity="1" style="display: block;">
                      <path fill="rgb(15,15,15)" fill-opacity="1"
                            d=" M32,1 C32,1 32,1 32,1 C32,1.5499999523162842 31.549999237060547,2 31,2 C31,2 1,2 1,2 C0.44999998807907104,2 0,1.5499999523162842 0,1 C0,1 0,1 0,1 C0,0.44999998807907104 0.44999998807907104,0 1,0 C1,0 31,0 31,0 C31.549999237060547,0 32,0.44999998807907104 32,1z"></path>
                    </g>
                    <g transform="matrix(1,0,0,1,0,15)" opacity="1" style="display: block;">
                      <path fill="rgb(15,15,15)" fill-opacity="1"
                            d=" M32,1 C32,1 32,1 32,1 C32,1.5499999523162842 31.549999237060547,2 31,2 C31,2 1,2 1,2 C0.44999998807907104,2 0,1.5499999523162842 0,1 C0,1 0,1 0,1 C0,0.44999998807907104 0.44999998807907104,0 1,0 C1,0 31,0 31,0 C31.549999237060547,0 32,0.44999998807907104 32,1z"></path>
                    </g>
                    <g transform="matrix(1,0,0,1,0,23)" opacity="1" style="display: block;">
                      <path fill="rgb(15,15,15)" fill-opacity="1"
                            d=" M32,1 C32,1 32,1 32,1 C32,1.5499999523162842 31.549999237060547,2 31,2 C31,2 1,2 1,2 C0.44999998807907104,2 0,1.5499999523162842 0,1 C0,1 0,1 0,1 C0,0.44999998807907104 0.44999998807907104,0 1,0 C1,0 31,0 31,0 C31.549999237060547,0 32,0.44999998807907104 32,1z"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <div data-menu="" class="heade__mobile-logic" bis_skin_checked="1">
        <ul role="list" class="header__list w-list-unstyled">
          <li class="header__list__item"><a href="/#home" class="header__list__item__link">Головна</a></li>
          <li class="header__list__item"><a href="/#about" class="header__list__item__link">Про нас</a></li>
          <li class="header__list__item"><a href="/#features" class="header__list__item__link">Переваги</a></li>
          <li class="header__list__item"><a href="/#projects" class="header__list__item__link">Проєкти</a></li>
          <li class="header__list__item"><a href="/#clients" class="header__list__item__link">Наші клієнти</a></li>
        </ul>
        <a data-openform="" href="#" class="header__cta w-inline-block"><p class="header__cta__text">Обговорити
          проєкт</p></a></div>
    </header>
  </div>
</template>

<script>
import { smoothScrollTo } from '@/utils/smoothScroll'

export default {
  name: 'HomePage',

  data() {
    return {
      isMenuActive: false,
      burgerEl: null,
      menuEl: null,
    };
  },

  mounted() {
    this.initBurgerMenu();
    document.addEventListener('click', this.handleAnchorClick);

  },

  beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('touchstart', this.handleTouchOutside);
    document.removeEventListener('click', this.handleAnchorClick);

    if (this.burgerEl) {
      this.burgerEl.removeEventListener('click', this.toggleMenu);
    }
  },

  methods: {
    initBurgerMenu() {
      this.burgerEl = document.querySelector('[data-burger]');
      this.menuEl = document.querySelector('[data-menu]');

      if (!this.burgerEl || !this.menuEl) return;

      this.burgerEl.addEventListener('click', this.toggleMenu);
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('touchstart', this.handleTouchOutside);
    },

    toggleMenu(force) {
      const next =
          typeof force === 'boolean'
              ? force
              : !this.menuEl.classList.contains('is--active');

      this.isMenuActive = next;
      this.menuEl.classList.toggle('is--active', next);
    },

    getHashFromLink(anchor) {
      const href = anchor.getAttribute('href') || '';
      const i = href.indexOf('#');
      return i === -1 ? '' : href.slice(i);
    },

    scrollToHash() {
      const hash = window.location.hash;
      if (!hash) return;

      const el = document.querySelector(hash);
      if (!el) return;

      smoothScrollTo(el);
    },

    handleDocumentClick(e) {
      if (!this.isMenuActive) return;

      // Клик по пункту меню
      const anchor = e.target.closest('[data-menu] a[href*="#"]');
      if (anchor) {
        e.preventDefault();

        const hash = this.getHashFromLink(anchor);
        if (!hash) return;

        this.toggleMenu(false);

        setTimeout(() => {
          window.location.hash = hash;
          this.scrollToHash();
        }, 250);

        return;
      }

      // Клик вне меню и бургера
      if (
          !e.target.closest('[data-menu]') &&
          !e.target.closest('[data-burger]')
      ) {
        this.toggleMenu(false);
      }
    },

    handleTouchOutside(e) {
      if (
          this.isMenuActive &&
          !e.target.closest('[data-menu]') &&
          !e.target.closest('[data-burger]')
      ) {
        this.toggleMenu(false);
      }
    },

    handleAnchorClick(e) {
      const anchor = e.target.closest('a[href*="#"]');
      if (!anchor) return;

      const href = anchor.getAttribute('href') || '';
      if (href === '#' || href === '/#') return;

      let url;
      try {
        url = new URL(anchor.href, window.location.origin);
      } catch {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (url.pathname !== window.location.pathname) return;
      if (!url.hash) return;

      const el = document.querySelector(url.hash);
      if (!el) return;

      e.preventDefault();
      history.pushState(null, '', url.pathname + url.hash);
      smoothScrollTo(el);
    },
  },
};
</script>


<style lang="scss" scoped>
@use '../../assets/scss/main.scss';
@use '../../assets/scss/layout/_header.scss';
</style>
